import { t } from '@/i18n';

export const registrationStatusStyles: Record<string, { label: string; dot: string; text: string; bg: string }> = {
  confirmed: { label: t('Confirmed'), dot: 'bg-green-400', text: 'text-green-400', bg: 'bg-green-500/10' },
  pending_review: { label: t('Pending'), dot: 'bg-amber-400', text: 'text-amber-400', bg: 'bg-amber-500/10' },
  waitlisted: { label: t('Waitlisted'), dot: 'bg-blue-400', text: 'text-blue-400', bg: 'bg-blue-500/10' },
  cancelled: { label: t('Cancelled'), dot: 'bg-gray-400', text: 'text-gray-500', bg: 'bg-gray-500/10' },
};

// Human labels for why a registration was cancelled (issue #400). Keep in sync with
// CancellationReason in apps/events/models.py.
export const cancellationReasonLabels: Record<string, string> = {
  declined: t('Declined'),
  cancelled_by_owner: t('Cancelled by organizer'),
  cancelled_by_attendee: t('Cancelled by attendee'),
  event_cancelled: t('Event cancelled'),
  payment_not_received: t('Payment not received'),
};

interface RegistrationStatusBadgeProps {
  status: string;
  // For a cancelled registration, the reason is surfaced as a subtle sub-label so the merged
  // cancelled bucket still tells the organizer *why* (e.g. a former "rejected").
  cancellationReason?: string | null;
}

export default function RegistrationStatusBadge({ status, cancellationReason }: RegistrationStatusBadgeProps) {
  const config = registrationStatusStyles[status] ?? {
    label: status, dot: 'bg-gray-400', text: 'text-gray-400', bg: 'bg-gray-500/10',
  };
  const reasonLabel =
    status === 'cancelled' && cancellationReason ? cancellationReasonLabels[cancellationReason] : undefined;
  return (
    <span className={`inline-flex items-center gap-x-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${config.bg} ${config.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${config.dot}`} />
      {config.label}
      {reasonLabel && <span className="font-normal opacity-70">· {reasonLabel}</span>}
    </span>
  );
}
